const EventState = Object.freeze({
  notHeld: 0,
  open: 1,
  inAggregating: 2,
  completeAggregate: 3,
  closed: 4,
})

export default EventState
